import React from "react";
import { Button } from "react-bootstrap";

export default function Logout(props) {
  return (
    <Button onClick={props.logout} variant="light">
      logout
    </Button>
  );
}
